export const parseMessagePayload = (payload) => {
	if (payload == null) return null;
	if (typeof payload === "object" && !Array.isArray(payload)) return payload;
	if (typeof payload === "string" && payload.trim() !== "") {
		try {
			const parsed = JSON.parse(payload);
			if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
				return parsed;
			}
		} catch {
			return null;
		}
	}
	return null;
};

export const getAnnotationAuthorPayload = (message) =>
	parseMessagePayload(message?.payload) ||
	parseMessagePayload(message?.metadata) ||
	null;

export const resolveAnnotationAuthorName = (message, fallback = "") => {
	const payload = getAnnotationAuthorPayload(message);
	if (payload?.userName && String(payload.userName).trim()) {
		return String(payload.userName).trim();
	}
	if (message?.user?.name && String(message.user.name).trim()) {
		return String(message.user.name).trim();
	}
	if (message?.user?.email && String(message.user.email).trim()) {
		return String(message.user.email).trim();
	}
	if (message?.ticket?.user?.name && String(message.ticket.user.name).trim()) {
		return String(message.ticket.user.name).trim();
	}
	if (message?.ticket?.user?.email && String(message.ticket.user.email).trim()) {
		return String(message.ticket.user.email).trim();
	}
	if (payload?.userEmail && String(payload.userEmail).trim()) {
		return String(payload.userEmail).trim();
	}
	return fallback;
};
